import React, { ReactNode } from "react";
import { ResourceName } from "../descriptors";
import { useRevalidator } from "react-router-dom";
import { IconButton, Tooltip } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import DeleteResourceDialog from "./DeleteResourceDialog";

/// button to open a create or update resource form in a dialog
const DeleteResourceButton: React.FC<{
    resourceName: ResourceName;
    id: number;
    disabled?: boolean;
    tooltip?: ReactNode;
}> = ({ resourceName, id, disabled = false, tooltip }) => {
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const revalidator = useRevalidator();

    const button = (
        <IconButton
            onClick={() => {
                setDialogOpen(true);
            }}
            sx={{
                color: "primary.main",
            }}
            disabled={disabled}
        >
            <FontAwesomeIcon icon={faTrash} />
        </IconButton>
    );

    return (
        <>
            {tooltip ? (
                <Tooltip title={tooltip} placement="top">
                    <span>{button}</span>
                </Tooltip>
            ) : (
                button
            )}
            <DeleteResourceDialog
                open={dialogOpen}
                hide={() => setDialogOpen(false)}
                id={id}
                resourceName={resourceName}
                onSuccess={() => {
                    setDialogOpen(false);
                    revalidator.revalidate();
                }}
            />
        </>
    );
};

export default DeleteResourceButton;
